









































import { Prop, Component, Mixins, Watch } from "vue-property-decorator";
import {
    calendarRows,
    Day,
    endOfDay,
    shortDayNames,
    trunc,
} from "../../date-picker/private/Utils";
import CalendarMixin from "./CalendarMIxin";

@Component
export default class CalendarMonthView extends Mixins(CalendarMixin) {
    @Prop() isMondayFirst!: boolean;

    private monthCellHTML: HTMLElement | null = null;
    private cellHeight = 0;
    private resizeObserver: ResizeObserver | null = null;
    private timerId: number | null = null;

    mounted() {
        this.addObserver();
    }
    destroyed() {
        this.resetObserver();
    }

    @Watch("rows")
    private async onRowsUpdate(){
        await this.delay(100);
        this.resetObserver();
        this.addObserver();
    }

    private resetObserver() {
        if (this.timerId !== null) {
            clearInterval(this.timerId);
            this.timerId = null;
        } else if (this.resizeObserver !== null) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
    private addObserver() {
        const elements = this.$refs.monthcell_00 as HTMLElement[];
        this.monthCellHTML = elements && elements.length > 0 ? elements[0] : null;
        if (window.ResizeObserver && this.monthCellHTML) {
            this.resizeObserver = new ResizeObserver((/* elements */) => this.checkCellSize());
            this.resizeObserver.observe(this.monthCellHTML);
        } else {
            this.timerId = window.setInterval(() => this.checkCellSize(), 500);
        }
    }

    @Watch("cellHeight", {immediate: true})
    private onCellHeightUpdate(){
        this.$emit('cell-height-updated', this.cellHeight);
    }

    private checkCellSize() {
        this.cellHeight = this.monthCellHTML!.clientHeight;
    }

    private dayIdx = [0,1,2,3,4,5,6];

    private get dayHeaders(): string[] {
        return shortDayNames(this.isMondayFirst);
        //return ['lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'dom'];
    }

    private get rows(): Day[][] {
        const rows = calendarRows(
            new Date(this.refDate.getFullYear(), this.refDate.getMonth(), 1),
            new Date(this.refDate.getFullYear(), this.refDate.getMonth(), 1),
            this.isMondayFirst
        );
        this.$emit("new-range", [
            trunc(rows[0][0].dt),
            endOfDay(rows[rows.length - 1][6].dt),
        ]);
        return rows;
    }

    private dayClass(
        day: Day,
        columnIndex: number,
        rowIndex: number
    ): { [key: string]: boolean } {
        return {
            "border-t border-border dark:border-border-dark": rowIndex === 0,
            "border-r border-border dark:border-border-dark": columnIndex === 6,
        };
    }

    private dayLabelClass(columnIndex: number ): { [key: string]: boolean } {
        return {
            "border-l": columnIndex === 0,
            "border-r": columnIndex === 6,
        };
    }

    private async delay (ms: number) {
        new Promise(res => setTimeout(res, ms));
    }

}
